import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Logo = ({ imageUrl, logoClass }) => {
  return (
    <Link to={"/"} className="">
      <img
        alt="store-logo"
        loading="lazy"
        className=""
        src={imageUrl}
        style={{
          width: "75px",
          height: "75px",
        }}
      />
    </Link>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
};

export default Logo;
